























































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import VideoStatusRuntimeHistory from '@/components/videoDevice/runtime/index.vue'

import { getRuntimeList } from '@/api/videoDevice/point'
import { DDLItem, DefDDLItem } from '@/api/common/select'
import { enFirstType } from '@/configs/enums'
import {
  getSubDDL, copyArray, toDefaultStr, toDefaultInt, tryToStr, tryToInt, jsonStoreage, dateFormat, mergeDateTimeRange, splitDateRange
} from '@/configs/functions'
import PageList from '@/components/pageLayout/list.vue'

import {
  PagePermissionState, PermissionData, FailedPermission
} from '@/store/modules/pagePermission'
import { UserData } from '@/api/systemManage/user'
import { namespace } from 'vuex-class'
const UserModule = namespace('user')
const PagePermissionModule = namespace('pagePermission')
const DataSourceModule = namespace('dataSource')

@Component({
  components: {
    PageList, VideoStatusRuntimeHistory
  }
})
/**视频状态运行检测 */
export default class VideoStatusRuntime extends Vue {
  public showMore: boolean = false
  @PagePermissionModule.Getter
  public pagePermission!: PagePermissionState
  public btnCtrl: PermissionData = FailedPermission
  public pagePath: string = ''
  public getPermission() {
    const s = this.pagePermission
    let p = FailedPermission
    let path = ''
    if (this.$route.path.indexOf(s.pagePath) > -1) {
      p = s.permission
      path = s.pagePath
    }
    this.btnCtrl = p
    this.pagePath = path
    var cacheQuery = jsonStoreage.getFilter(path)
    if (cacheQuery && cacheQuery != null) {
      this.queryTerm = Object.assign({}, cacheQuery)
      jsonStoreage.removeFilter(path)
    }
    else {
      this.getQueryTerm()
    }
  }
  @UserModule.Getter('userInfo')
  public curUser!: UserData
  
  get dateRange(): string[] {
    // console.log(this.sDate, this.eDate)
    const qt = this.queryTerm
    return mergeDateTimeRange(qt.StartDate, qt.EndDate)
  }
  set dateRange(range: string[]) {
    const qt = this.queryTerm
    const d = splitDateRange(range)
    qt.StartDate = d.start
    qt.EndDate = d.end
  }
  public listLoading: boolean = true
  public totalItems: number = 0
  public totalPages: number = 0
  public pageSize: number = window.baseConfig.PageSize

  public firstType: number = enFirstType.All
  public defItem: DDLItem = DefDDLItem(this.firstType)

  public cityList: DDLItem[] = []
  public countyList: DDLItem[] = [this.defItem]
  //--0全部 1离线 2在线 3未知
  public statusList: any = [
    { Key: 0, Val: '--全部--' },
    { Key: 2, Val: '在线' },
    { Key: 1, Val: '离线' },
    { Key: 3, Val: '未知' }
  ]
  public list: any[] = []
  public summary: any = {
    TotalCount: 0,
    OnlineCount: 1,
    OfflineCount: 2,
    UnknownCount: 3,
    OnlineRate: 0.5
  }

  public dateTimeFormat = window.baseConfig.DateTimessFormat
  private sDate = this.defDate(true)
  private eDate = this.defDate(false)
  private defDate(start: boolean) {
    var format = window.baseConfig.DateFormat
    var today = new Date()
    var dt = dateFormat(today, format)
    if (start) {
      dt += " 00:00:00"
    }
    else {
      dt += " 23:59:59"
    }
    return dt
  }
  public queryTerm = {
    Page: 1,
    PageSize: this.pageSize,
    SortBy: 'CheckTime',
    IsAsc: false,

    CityId: 0,
    CountyId: 0,

    OnlineStatus: 0,
    StartDate: this.sDate,
    EndDate: this.eDate,
    Keyword: ''
  }
  // 保存最新的一次查询参数，用来保证分页，排序，导出时保证查询条件不变
  public lastQuery = Object.assign({}, this.queryTerm)
  public getQueryTerm() {
    const query = this.$route.query
    // 从页面Url中获取参数
    this.queryTerm = {
      PageSize: toDefaultInt(query['PageSize'], this.pageSize),
      Page: toDefaultInt(query['Page'], 1),
      SortBy: toDefaultStr(query['SortBy'], 'CheckTime'),
      IsAsc: tryToStr(query['IsAsc']) == 'true',

      CityId: tryToInt(query['CityId']),
      CountyId: tryToInt(query['CountyId']),

      OnlineStatus: tryToInt(query['OnlineStatus']),
      StartDate: toDefaultStr(query['StartDate'], this.sDate),
      EndDate: toDefaultStr(query['EndDate'], this.eDate),
      Keyword: tryToStr(query['Keyword'])
    }
  }
  get startIndex() {
    return this.queryTerm.PageSize * (this.queryTerm.Page - 1) + 1
  }
  get tableSort() {
    return {
      prop: this.queryTerm.SortBy,
      order: this.queryTerm.IsAsc ? 'ascending' : 'descending'
    }
  }
  //页面控制
  public setRowClass(data: { row: any, rowIndex: number }) {
    const row = data.row
    let name = ''
    if (row.IsSourceDelete > 0) {
      //源视频已删除
      name = 'color-info'
    }
    return name
  }
  // 选中项,这里存的是整个行的数据
  public selectedRows: any[] = []
  // 多选的时候，用到，返回选中的行，这里存的是数组
  public selectedChange(val: never[]) {
    this.selectedRows = val
  }
  // 点击排序按钮的时候，按新排序查询数据
  public sortChange(col: { [key: string]: string }) {
    const query = this.lastQuery
    const asc = col.order === 'ascending' // descending
    if (query.SortBy !== col.prop || query.IsAsc !== asc) {
      query.SortBy = col.prop
      query.IsAsc = asc
      this.refreshData()
    }
  }
  // 分页按钮点击的时候，按新分页查询数据
  public pageEvent() {
    const qt = this.queryTerm
    const query = this.lastQuery
    query.Page = qt.Page
    query.PageSize = qt.PageSize
    this.refreshData()
  }
  // 点击查询按钮时，页码需要重置为1
  public doSearch() {
    this.queryTerm.Page = 1
    this.fetchData(this.queryTerm)
  }
  public created() {
    this.getPermission()
    this.fetchSource()
  }
  public mounted() {
    this.doSearch()
  }
  public beforeDestroy() { }

  @DataSourceModule.Getter('cityList')
  public cityCounty!: any
  @DataSourceModule.Getter('dataSource')
  public dataSource!: any
  public fetchSource() {
    var cityCounty = copyArray(this.cityCounty)
    if (cityCounty) {
      this.cityList = cityCounty
      if (cityCounty.length == 2) {
        this.queryTerm.CityId = cityCounty[1].Key
      }
      if (this.queryTerm.CityId > 0) {
        this.cityChange(0)
      }
    }
  }
  public cityChange(reset: number) {
    const qt = this.queryTerm
    this.countyList = [this.defItem]
    if (reset === 1) {
      qt.CountyId = 0
    }
    if (qt.CityId > 0) {
      this.countyList = getSubDDL(this.cityList, qt.CityId)
      if (this.countyList.length == 1) {
        qt.CountyId = this.countyList[0].Key
      }
    }
  }
  public fetchData(query: any) {
    this.listLoading = true
    getRuntimeList(query).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        var rst = data.Results
        this.summary = rst.summary[0]
        this.list = rst.list
        this.totalPages = data.TotalPages
        this.totalItems = data.TotalCount

        this.queryTerm.PageSize = data.PageSize
        this.queryTerm.Page = query.Page
        this.queryTerm.SortBy = query.SortBy
        this.queryTerm.IsAsc = query.IsAsc

        this.lastQuery = Object.assign({}, query)
        jsonStoreage.setFilter(this.pagePath, query)
      }
      this.listLoading = false
    })
  }
  public refreshData() {
    this.fetchData(this.lastQuery)
  }
  public showHistory(index: number) {
    var pointId = this.list[index].PointId
    window.eventBus.$emit('showRuntimeHistory', pointId)
  }
  // 在当前路由改变，但是该组件被复用时调用
  @Watch('$route')
  public onRouteChange(route: any) {
    this.getPermission()
    const qt = this.queryTerm
    if (qt.CityId > 0) {
      this.cityChange(0)
    }
    this.doSearch()
  }
}
